// cn.js
const CN = {
    type: "CN",
    lang: "中文",

    // 首页-页眉字符
    index_1: "首页",
    index_2: "关于我们",
    index_3: "公司简介",
    index_4: "荣誉资质",
    index_5: "企业文化",
    index_6: "产品中心",
    index_7: "新闻资讯",
    index_8: "服务支持",
    index_9: "产品咨询",
    index_10: "售后服务",
    index_11: "帮助文档",
    index_12: "服务热线",
    // 首页-主体字符
    index_23: "联系我们",
    index_24_1: "电话：15910967510",
    index_25_1: "邮箱：andaf@sina.com",
    index_27_1: "地址：",
    index_28_1: "北京市昌平区沙河新飞达科技发展中心F6-3",

    // 首页-页脚字符
    foot_1: "为什么选择帕斯卡尔",
    foot_2: "最新产品",
    foot_6: "提交",
    foot_7: "官方微信",
    foot_8: "手机端",

    // 手机底部导航栏
    mobile_foot1: "首页",
    mobile_foot2: "产品",
    mobile_foot3: "资讯",
    mobile_foot4: "文档",

    // 首页-关于我们模块
    home_about_title: "帕斯卡尔科技",
    home_about_subtitle: "掌握流体领域核心技术",
    home_about_description: "帕斯卡尔(北京)流体科技有限公司是一家致力于医疗领域、生命科学领域、科学仪器领域设备及配件研发的高科技公司。\n公司秉承着“诚信、专业、高效”的经营理念在“掌握流体领域核心技术”的基础上持续创新，为客户提供高品质的产品和服务。公司先后推出的工业超精密注射泵、柱塞泵、高压输液泵、单向阀、旋转阀、过滤器、管路、接头等类型产品，凭借超前的技术优势和过硬的品质，得到了用户的一致好评！\n此外，公司拥有高效的研发团队和一流的研磨抛光设备，可以根据用户需求实现快速定制，并提供流体类零部件的整体解决方案。",
    home_about_more: "了解更多 +",
    home_about_stat1_value: "10",
    home_about_stat1_unit: "年+",
    home_about_stat1_label: "专注流体技术领域",
    home_about_stat2_value: "50",
    home_about_stat2_unit: "款+",
    home_about_stat2_label: "自主研发精密产品",
    home_about_stat3_value: "300",
    home_about_stat3_unit: "家+",
    home_about_stat3_label: "全球服务客户",

    // 其他页面
    text1: "请输入内容",
    text2: "正在加载...",
    text3: "立即咨询",
    text4: "公司名称",
    text5: "产品名称",
    text6: "联系方式",
    text7: "备注",
    text8: "支持手机、邮箱、固定电话等联系方式，我们会在第一时间联系您。",
    text10: "产品详情",
    text11: "产品文档",
    consultation_tag: "需求沟通",
    consultation_page_title: "为什么选择我们",
    consultation_subtitle: "围绕精密流体控制场景，我们更关注部件精度、材料适配与应用稳定性，帮助您更快确认合适的产品方案。",
    consultation_advantage_1_title: "精密加工",
    consultation_advantage_1_desc: "具备微米级精密加工经验，注重关键尺寸一致性与装配稳定性。",
    consultation_advantage_2_title: "材料适配",
    consultation_advantage_2_desc: "熟悉陶瓷、工程塑料等多类材料选型，可结合介质特性与耐腐蚀要求给出建议。",
    consultation_advantage_3_title: "应用经验",
    consultation_advantage_3_desc: "基于 OEM 设备与实际工况的应用积累，帮助您更高效地确认方案。",
    consultation_info_tag: "沟通重点",
    consultation_info_title: "欢迎告知您的应用场景与需求，我们将尽快为您匹配方案",
    consultation_focus_1_title: "应用场景",
    consultation_focus_1_desc: "可补充介质类型、设备型号、流量或压力范围，便于快速判断匹配方案。",
    consultation_focus_2_title: "产品方向",
    consultation_focus_2_desc: "如已有目标产品、型号或替代需求，建议一并说明，我们会结合现有产品线进行确认。",
    consultation_focus_3_title: "交付要求",
    consultation_focus_3_desc: "若涉及打样、交期或定制加工要求，可提前备注，便于安排对应人员跟进。",
    consultation_helper: "提交后，我们会尽快与您联系，并结合实际工况提供沟通建议。",
    consultation_form_tag: "在线提交",
    consultation_form_title: "填写您的咨询信息",
    consultation_form_desc: "信息越完整，我们给出的建议会越贴近实际使用场景。",
    consultation_prefill: "当前咨询产品",
    consultation_company_label: "您的公司名称",
    consultation_company_placeholder: "请输入公司名称或单位名称",
    consultation_product_label: "您想要咨询的产品",
    consultation_product_placeholder: "请输入产品名称、型号或应用方向",
    consultation_contact_label: "您的联系方式",
    consultation_contact_placeholder: "请填写手机号、邮箱或微信，便于我们尽快联系您",
    consultation_requirement_label: "您的其他要求",
    consultation_requirement_placeholder: "可补充介质类型、使用工况、交期或定制要求",
    consultation_submit: "提交咨询",
    consultation_submit_error: "提交失败，请稍后重试。",

}
export default CN
